export default __webpack_public_path__ + "static/media/Lissie-Garvin.e2a5c192.png";